import React from "react";
import { useTranslation } from "react-i18next";
import Newsletter from "components/layout/Newsletter";
import ImageGallery from "react-image-gallery";

// Images & Icons
import home_banner_desktop from "assets/images/home_banner_desktop.jpg";
import home_banner_mobile from "assets/images/home_banner_mobile.jpg";

function About() {
  const { t } = useTranslation();

  // NOTE: this used to embed a gallery of GNG's own event photos + a Google
  // Drive recap video. Swap the paragraphs/gallery below for real Topgolf
  // Tournament 2026 photography once it's available.
  const about = {
    description: (
      <>
        <p className="text-justify app-animation-translate-start">
          {t("aboutUsParagraph1")}
        </p>
        <br />
        <p className="text-justify app-animation-translate-start">
          {t("aboutUsParagraph2")}
        </p>
      </>
    ),
  };

  return (
    <div>
      <section>
        <div className="relative">
          {/* home banner desktop size */}
          <img
            // src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1c0610da06e3edba525e31bbf4bf526fa276d28803c039a64992d024874448b71b02826c5169acbf1c7c61b0dd764488a8a0bf8cd98872c2474650c847a0ffe234f1c22d82f685685cc5bfa38d5bd67b3cfa88080b46a965d68d693de5546d5439ef6d2d5800e97258a00974dc45dfebf67e847305ed821e943f/file-1736775970398.jpg"
            src={home_banner_desktop}
            alt="main"
            className="object-cover object-center w-full max-h-40 sm:max-h-60"
          />
          <div className="absolute top-0 bottom-0 left-0 right-0 text-white bg-black/60">
            <div className="flex flex-col items-center justify-center h-full gap-4 app-main-container sm:gap-8">
              <p className="max-w-md px-8 text-lg font-semibold text-center sm:text-3xl sm:font-bold app-animation-translate-start">
                {t("aboutUsBannerText")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="space-y-4 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("aboutUs")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {about.description}
          </div>
        </div>
      </section>

      {/* <section className='bg-app-grey'>
        <div className='grid items-center grid-cols-1 gap-4 app-main-container sm:grid-cols-2 sm:gap-8'>
          <img className='app-animation-translate-right-start' src={visionMission} alt="vision and mission" />
          <div className='space-y-4 app-animation-translate-start'>
            <div>
              <p className='text-sm font-bold uppercase sm:text-base md:text-lg'>Vision</p>
              <p className='text-sm font-medium sm:text-base md:text-lg'>Lorem ipsum dolor sit amet lorem ipsum dolor sit amet</p>
            </div>
            <div>
              <p className='text-sm font-bold uppercase sm:text-base md:text-lg'>Mission</p>
              <p className='text-sm font-medium sm:text-base md:text-lg'>Lorem ipsum dolor sit amet lorem ipsum dolor sit amet</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className='bg-app-grey'>
        <div className='space-y-8 app-main-container'>
          <p className='text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start'>
            {t('aboutUsTitle2')}
          </p>
          <div>
            <ImageGallery items={about.our_role_img} showThumbnails={false} showPlayButton={false} />
          </div>
        </div>
      </section> */}

      {/* <Newsletter /> */}
    </div>
  );
}

export default About;
